import React from "react";
import { CaretDownIcon, CaretUpIcon } from "@phosphor-icons/react";

const COLUMNS = [
    { key: "date", label: "Date", className: "date" },
    { key: "project", label: "Projet", className: "project" },
    { key: "task", label: "Tâche", className: "task" },
    { key: "comments", label: "Commentaires", className: "comments" },
    { key: "duration", label: "Durée", className: "duration" },
];

const TimeTableHeader = ({ sortConfig, requestSort, hasEntries, isDragDisabled }) => {
    const renderSortIcon = (key) => {
        if (sortConfig.key !== key) return null;
        return sortConfig.direction === "asc" ? <CaretUpIcon size={12} /> : <CaretDownIcon size={12} />;
    };

    const showDragColumn = hasEntries && !isDragDisabled;

    return (
        <thead>
            <tr>
                {showDragColumn && <th className="customOrder"></th>}
                {COLUMNS.map(({ key, label, className }) => (
                    <th key={key} className={className} onClick={() => requestSort(key)}>
                        {label} {renderSortIcon(key)}
                    </th>
                ))}
                <th className="actions">Actions</th>
            </tr>
        </thead>
    );
};

export default React.memo(TimeTableHeader);
